import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

const getScreenRecordingState = (state: RootState) => state.screenRecording;

export const getContactRecordingStateSelector = createSelector(
  [getScreenRecordingState],
  (screenRecording) => screenRecording?.contactRecordingState,
);

export const getContactRecordingLoadingStateSelector = createSelector(
  [getScreenRecordingState],
  (screenRecording) => screenRecording?.loading,
);

export const getContactRecordingStateErrorSelector = createSelector(
  [getScreenRecordingState],
  (screenRecording) => screenRecording?.error,
);
